import "./LogoMarquee.scss";

// assets
import moneycontrol_img from "../../../assets/common/moneycontrol.png";
import telanganaToday_img from "../../../assets/common/telangana-today.png";
import inc42_img from "../../../assets/common/inc42.png";
import yourstory_img from "../../../assets/common/yourstory.png";
import mint_img from "../../../assets/common/mint.png";
import deccanChronicle_img from "../../../assets/common/deccan-chronicle.png";
import vccircle_img from "../../../assets/common/vccircle.png";
import businessLine_img from "../../../assets/common/business-line.png";
import businessStandard_img from "../../../assets/common/business-standard.png";
import cnbc_img from "../../../assets/common/cnbc.png";
import economicTimes_img from "../../../assets/common/economic-times.png";
import timesOfIndia_img from "../../../assets/common/times-of-india.png";
import pocketGamer_img from "../../../assets/common/pocketgamer.png";

// code imports
import React from "react";
import Marquee from "react-fast-marquee";

// scale = visual weight tweak per logo (the files have very different proportions)
// href = optional article link (the logo becomes clickable)
export const PRESS_LOGOS = [
    { src: timesOfIndia_img, scale: 1.3, name: "The Times of India" },
    { src: inc42_img, scale: 1, name: "Inc42", href: "https://inc42.com/buzz/hitwicket-bags-funding-to-build-strategy-driven-cricket-gaming-studio/" },
    { src: economicTimes_img, scale: 0.7, name: "The Economic Times" },
    { src: telanganaToday_img, scale: 1, name: "Telangana Today", href: "https://telanganatoday.com/hyderabad-hitwicket-raises-rs-24-crore-launches-hitwicket-superstars" },
    { src: cnbc_img, scale: 0.95, name: "CNBC" },
    { src: moneycontrol_img, scale: 1, name: "Moneycontrol", href: "https://www.moneycontrol.com/news/trends/sports-trends/world-cup-2019-a-look-at-how-the-gaming-industry-is-trying-to-scale-up-engagement-4059321.html" },
    { src: businessStandard_img, scale: 0.75, name: "Business Standard" },
    { src: yourstory_img, scale: 1, name: "YourStory", href: "https://yourstory.com/2020/08/hitwicket-cricket-gaming-app-aatmanirbhar-bharat-pm-modi" },
    { src: pocketGamer_img, scale: 1.05, name: "PocketGamer.biz" },
    { src: mint_img, scale: 1, name: "Mint", href: "https://www.livemint.com/technology/tech-news/bet-on-global-markets-reaping-benefits-for-indian-gaming-cos-11634842954637.html" },
    { src: deccanChronicle_img, scale: 1, name: "Deccan Chronicle", href: "https://www.deccanchronicle.com/business/companies/031122/hitwicket-launches-cricket-strategy-game-hitwicket-superstars.html" },
    { src: vccircle_img, scale: 1, name: "VCCircle", href: "https://www.vccircle.com/hitwicketbattre-raise-early-stage-funding" },
    { src: businessLine_img, scale: 1, name: "The Hindu BusinessLine", href: "https://www.thehindubusinessline.com/info-tech/hitwicket-raises-3-million-from-prime-venture-partners/article66091944.ece" },
];

/**
 * Slow, white, pause-on-hover marquee of the press logos. Used on the home and About pages.
 * gradientColor should match the page background so the edge fade blends in.
 */
function LogoMarquee({ gradientColor = [26, 6, 47] }) {
    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

    return (
        <Marquee speed={isMobile ? 20 : 40} pauseOnHover gradientColor={gradientColor} gradientWidth="15%">
            {PRESS_LOGOS.map(({ src, scale, name, href }) => {
                const img = (
                    <img
                        src={src}
                        alt={name}
                        className="LogoMarquee-logo"
                        style={{ height: `calc(clamp(22px, 3.2vw, 38px) * ${scale})` }}
                    />
                );
                return href ? (
                    <a key={src} href={href} target="_blank" rel="noopener noreferrer" className="LogoMarquee-item">
                        {img}
                    </a>
                ) : (
                    <span key={src} className="LogoMarquee-item">{img}</span>
                );
            })}
        </Marquee>
    );
}

export default LogoMarquee;
